<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// This replaces the old manual JSON parsing + lazy fallbacks pattern
// If config is invalid, parseAndValidateConverterConfig() throws with detailed error
// NOTE: jobCategory, labels, and creditCost are now provided by backend
const converterConfig = parseAndValidateConverterConfig('jpg-to-png-converter', 'JPG → PNG');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[JPG→PNG] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[JPG→PNG] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[JPG→PNG] Batch cleared');
}

function handleError(error: Error) {
  console.error('[JPG→PNG] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[JPG→PNG] Credits updated:', credits);
}
</script>
